import { Component, ViewChild, ElementRef } from '@angular/core';
// importing the superclass
import { Module } from './../module.component';
// services import
import { Status } from './../../service/status.service';
import { DeliveryService } from './delivery.service';
// managers
import * as _ from 'underscore';
// components
import { ModalDeliveryPrintComponent } from '../MODAL-delivery-print/modal-delivery-print.component';

// component definition
@Component({
  selector: 'app-delivery',
  templateUrl: './delivery.component.html',
  providers:
    [
      DeliveryService
    ]
})
export class DeliveryComponent extends Module {

  // input values
  order_number =                                        '';
  date_from =                                           '';
  date_to =                                             '';
  draft_date =                                          '';

  globalExpansion =                                     false;

  fromIFSR =                                            false;
  order_number_oda =                                    '';

  searchByDateEnable = false;

  // form object values
  @ViewChild('order_number_form') order_number_form:    ElementRef;
  @ViewChild('date_from_form') date_from_form:          ElementRef;
  @ViewChild('date_to_form') date_to_form:              ElementRef;

  constructor(private deliveryService:                  DeliveryService,
              private status:                           Status) {
    super();
    this.setBindExposer(this.status.getExposer());
    this.getExposer().getModelsManager().delivery_request;

    this.setFormEnable(this.getCustomizingService().getBoolean('DELIVERY.LIST.FORM.ENABLE', false));
    this.setAutoSearchEnable(this.getCustomizingService().getBoolean('DELIVERY.LIST.AUTOSEARCH.ENABLE', false));
    this.setSearchByDateEnable(this.getCustomizingService().getBoolean('DELIVERY.LIST.FORM.DATE.ENABLE', false));

    if (this.searchByDateEnable) {
      this.setTodayDate();
      this.setDefaultDateFrom();
      this.setDefaultDateTo();
      this.redrawDatesInputField();
    }

    this.requestModelSetUp();
    // check for the IFRS triggers
    if (this.getIFRS().getHomeFunctions().FLAG_getDeliveries === true) {
      this.order_number = this.getIFRS().getHomeFunctions().getDeliveries_order_number;
      this.order_number_oda = this.order_number;
      this.fromIFSR = true;
      // this.doSearch();
      this.getIFRS().clearAllFunctionsData();
      this.doSearch();
    } else if (this.getAutoSearchEnable()) {
      this.fromIFSR = false;
      this.doSearch();
    }
  }

  // check for back button
  isFromIFRS() {
    return this.fromIFSR;
  }

  // come back to delivery in previous state
  backTo() {
    this.getIFRS().clearAllFunctionsData();
    this.getIFRS().getHomeFunctions().FLAG_getDetails = false;
    this.getIFRS().getSidebar().setMenuItem('order');
  }

   // set up the request model
  requestModelSetUp() {
    this.getModelsManager().delivery_request.order_number = '';
    this.getModelsManager().delivery_request.supplier_code = this.getAccountService().supplierProperties.supplier_code;
    this.getModelsManager().delivery_request.company_code = this.getAccountService().getUserCompany().code;
    this.getModelsManager().delivery_request.language = this.getLocale().getPreferredLanguage();
  }

  // send the query to the server
  doSearch() {
    if (this.order_number !== '') {
      this.getModelsManager().delivery_request.order_number = this.order_number;
    } else {
      this.fromIFSR = false;
    }
    this.deliveryService.serchDelivery();
    this.showSearchParameters = false;
  }

   // method that handles the change of the supplier code field
  updateOrderNumber() {
    this.order_number = this.order_number_form.nativeElement.value;
    this.getModelsManager().delivery_request.order_number = this.order_number;
  }

  // method that handles the change of the 'from' date
  changeFromDate() {
    this.date_from = this.date_from_form.nativeElement.value;
    if (this.date_from === undefined || this.date_from === '') {
      this.setDefaultDateFrom();
    }
    this.redrawDatesInputField();
  }

  // method that handles the change of the 'to' date
  changeToDate() {
    this.date_to = this.date_to_form.nativeElement.value;
    if (this.date_to === undefined || this.date_to === '') {
      this.setDefaultDateTo();
    }
    this.redrawDatesInputField();
  }

  // set the today date
  setTodayDate() {
    this.getDateTimeManager().setToday();
    this.draft_date = this.getDateTimeManager().ddmmyyyy('-');
  }

  // set the from date (today)
  setDefaultDateFrom() {
    const backwardsDays = -30;
    this.getDateTimeManager().dateCalculation(new Date(), backwardsDays, 'd');
    this.date_from = this.getDateTimeManager().yyyymmdd('-');
  }

  // set the to date
  setDefaultDateTo() {
    const fowardDays = 30;
    this.getDateTimeManager().dateCalculation(new Date(), fowardDays, 'd');
    this.date_to = this.getDateTimeManager().yyyymmdd('-');
  }

  // redraw the date input fields with a valid value
  redrawDatesInputField() {
    if (this.date_from_form !== undefined) { this.date_from_form.nativeElement.value = this.date_from; }
    if (this.date_to_form !== undefined) { this.date_to_form.nativeElement.value = this.date_to; }
  }

  // Returns normalized date
  getNormalDate(value) {
    if (value !== null && value !== undefined) {
      const date = new Date(value);
      this.getDateTimeManager().setDate(date);
      const text = this.getDateTimeManager().ddmmyyyy('/');
      return text;
    } else {
      return '';
    }
  }

  // clear the input values
  clearFormValues() {
    this.order_number = '';
    this.setDefaultDateFrom();
    this.setDefaultDateTo();
    this.redrawDatesInputField();
    this.requestModelSetUp();
  }

  // wrapper functions
  isServiceSearching() {
    return this.deliveryService.isSearching();
  }

  // returns the status of the server query
  isResultEmpty() {
    return this.deliveryService.getDeliveries().length === 0;
  }

  // returns the request model
  getRequestModel() {
    return this.getModelsManager().delivery_request;
  }

  // returns the response model
  getDeliveryServiceResponse() {
    return this.getOrderedList(this.deliveryService.getDeliveries(), this.sortType, this.sortReverse);
  }

  // shows the modal of the prints
  showPrints(modal: ModalDeliveryPrintComponent, values, headers) {
    const modelPrintsArray = _.groupBy(values, 'text_code');
    modal.setPrints(values, headers.delivery_number);
    modal.show();
  }

  getOrderByDelivery(orderNumber) {
    this.getIFRS().clearAllFunctionsData();
    this.getIFRS().getHomeFunctions().FLAG_getDetails = true;
    this.getIFRS().getHomeFunctions().getDetails_order_number = orderNumber;
    this.getIFRS().getSidebar().setMenuItem('order');
  }

  setSearchByDateEnable(value: boolean) {
    this.searchByDateEnable = value;
  }

  getSearchByDateEnable() {
    return this.searchByDateEnable;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/delivery/delivery.component.ts